import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IUserPreference } from 'src/app/auth/models/user-preference';
import { ICurrentProgrammeResponse } from '../components/my-profile/my-profile.component';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  // public claim_free_diet_eligibility$ = new BehaviorSubject<any>({});

  constructor(private httpClient: HttpClient) {}

  getCurrentProgram(): Observable<ICurrentProgrammeResponse> {
    return this.httpClient
      .get<ICurrentProgrammeResponse>('/api/Users/current_packages');
}

  saveDeviceToken(obj) {
    return this.httpClient
      .post('/api/Notifications/user_device_token', obj)
      .pipe((res) => res);
  }

  deleteDeviceToken(obj) {
    return this.httpClient
      .post('/api/Notifications/delete_device_token', obj)
      .pipe((res) => res);
  }

  checkDeviceToken() {
    return this.httpClient.get(`/api/Notifications/device_tokens_by_user_id`);
  }

  getProfile(): Observable<any> {
    return this.httpClient.get('/api/users/client_details').pipe((res) => res);
  }

  getBMI() {}

  freeDietEligibilityCheck() {
    return this.httpClient.get('/api/Users/check_free_diet_eligibility');
  }

  freeDietEligibility() {
    return this.httpClient.get('/api/Users/check_free_diet_eligibility');
    // this.httpClient
    //   .get('/api/Users/check_free_diet_eligibility')
    //   .subscribe((res: any) => {
    //     this.claim_free_diet_eligibility$.next(res.isValid);
    //   }, (err) => {
    //     this.claim_free_diet_eligibility$.next(err.error.isValid);
    //     console.log(err);
    //   });
  }

  getCounsellorOfUser() {}

  getCoins() {}

  getOrders() {}

  getInvoices() {}

  downloadInvoice() {}

  updateProfile() {}

  updateGoalWeightAndCurrentWeight() {}

  updateDietTags() {}

  getReferrerCode() {
    return this.httpClient.get('/api/users/referral_codes');
  }

  checkProfileCompletion() {
    return this.httpClient.get('/api/users/check_client_profile_completion');
  }

  updatePhoneNumber(phone): Observable<any> {
    return this.httpClient
      .post('/api/Users/addPhoneNumber', phone)
      .pipe((res) => res);
  }

  updateWeight(weight): Observable<any> {
    return this.httpClient
      .post('/api/users/update_weight', weight)
      .pipe((res) => res);
  }

  saveUserBMI(bmi): Observable<any> {
    return this.httpClient.post('/api/users/save_bmi', bmi).pipe((res) => res);
  }

  getUserPreference() {
    return this.httpClient
      .get('/api/users/user_preferences')
      .pipe((res) => res);
  }

  postUserPreference(preferenceObj) {
    return this.httpClient
      .post('/api/users/user_preferences', preferenceObj)
      .pipe((res) => res);
  }

  getUserNotificationsList(object): Observable<any> {
    return this.httpClient
      .post('/api/notifications/notifications_v2', object)
      .pipe((res) => res);
  }

  updateNotifications(object): Observable<any> {
    return this.httpClient
      .post('/api/notifications/update_notifications', object)
      .pipe((res) => res);
  }

  getUserPreferenceDetail(): Observable<any | null> {
    return (this.getUserPreference() as Observable<IUserPreference>).pipe(
      map((res) => res.data?.[0] ?? null)
    );
  }

  getCounsellorDeviceToken() {
    return this.httpClient.get('/api/Chat/admin_user_token').pipe((res) => res);
  }

  uploadProfilePic(formData: FormData) {
    return this.httpClient.post('/api/Users/upload_profile_image', formData);
  }

  getArLinkedClientList(reqObj): Observable<any> {
    return this.httpClient.post(
      `/api/Auth/get_ar_linked_account_list_by_client_id`,
      reqObj
    );
  }

  generateTokenByClientId(reqObj): Observable<any> {
    return this.httpClient.post(`/api/Auth/token_by_client`, reqObj);
  }

  getReviewslist(reqObj): Observable<any> {
    return this.httpClient.post(`/api/users/get_all_reviews_list`, reqObj);
  }

  createClientReview(reqObj): Observable<any> {
    return this.httpClient.post(`/api/users/create_client_review`, reqObj);
  }

  uploadClientReviewImage(formData: FormData) {
    return this.httpClient.post(
      '/api/Users/upload_client_review_image',
      formData
    );
  }

  updateTermConsent(obj: { terms_consent: number }) {
    return this.httpClient.post('/api/Users/update_terms_consent', obj);
  }

  getTermsConsent() {
    return this.httpClient.get('/api/Users/terms_consent');
  }

  getTrainingProgrammes() {
    return this.httpClient.get('/api/Users/user_training_programmes');
  }

  checkUserPermissions(obj){
        return this.httpClient.post('/api/Users/check_client_permissions', obj);
  }
}
